export const ADMIN_PATH = '/admin';
